import { jsxs as v, jsx as a } from "react/jsx-runtime";
import c from "react";
import { R as b } from "./Description.be3b00d1.js";
import { _ as h, a as I, b as L } from "./vendor_rango__tokens.38ee67b0.js";
import r, { css as t } from "styled-components";
import { RangoAvatarBusiness as x, AvatarBusinessSize as y } from "../es/AvatarBusiness.js";
import { RangoAvatar as C, AvatarSize as R } from "../es/Avatar.js";
import { RangoCreditCard as w } from "../es/CreditCard.js";
import { R as z, I as M } from "./index.cff5baaf.js";
import { RangoImage as S, ImageAspectRatio as k } from "../es/Image.js";
import { c as _, u as j } from "./useClickMotion.0a3ea4e5.js";
const A = r.div.withConfig({
  displayName: "ListInfo",
  componentId: "sc-1yuc13v-0"
})(["display:inline-flex;flex-direction:column;justify-content:center;align-items:flex-start;gap:var(--size-half);"]), N = r.span.withConfig({
  displayName: "Label",
  componentId: "sc-1yuc13v-1"
})(["", " color:var(--text-label-color);text-align:left;"], h), O = r(b).withConfig({
  displayName: "Description",
  componentId: "sc-1yuc13v-2"
})(["text-align:left;"]), W = c.forwardRef(({
  label: n = "",
  description: e = "",
  ...i
}, s) => /* @__PURE__ */ v(A, { ref: s, ...i, children: [
  /* @__PURE__ */ a(N, { children: n }),
  e && /* @__PURE__ */ a(O, { children: e })
] })), u = {
  AvatarIcon: "avatar-icon",
  AvatarBusiness: "avatar-business",
  Icon: "icon",
  Image: "image",
  CreditCard: "credit-card"
};
Object.values(u);
const D = r.div.withConfig({
  displayName: "ListShape",
  componentId: "sc-y2n95g-0"
})(["display:inline-flex;align-items:center;justify-content:flex-start;"]), B = r(S).withConfig({
  displayName: "Image",
  componentId: "sc-y2n95g-1"
})(["width:var(--size-6x);height:var(--size-6x);"]), T = r(z).withConfig({
  displayName: "Icon",
  componentId: "sc-y2n95g-2"
})([""]), X = c.forwardRef(({
  icon: n,
  src: e = "",
  alt: i = "",
  flag: s,
  inverse: l = !1,
  type: d = u.Icon,
  ...f
}, p) => /* @__PURE__ */ a(D, { ref: p, ...f, children: (() => ({
  icon: /* @__PURE__ */ a(T, { size: M.MD, icon: n, inverse: l }),
  image: /* @__PURE__ */ a(B, { aspectRatio: k["1:1"], src: e, alt: i }),
  "avatar-icon": /* @__PURE__ */ a(C, { size: R.SM, src: e, ariaLabel: i }),
  "avatar-business": /* @__PURE__ */ a(x, { size: y.SM, src: e, ariaLabel: i }),
  "credit-card": /* @__PURE__ */ a(w, { flag: s })
})[d])() })), o = {
  Container: "container",
  Line: "line",
  Outline: "outline"
};
Object.values(o);
const $ = (n) => r(n).withConfig({
  displayName: "List",
  componentId: "sc-5updsc-0"
})(["all:unset;position:relative;width:100%;height:var(--size-10x);box-sizing:border-box;display:flex;align-items:center;justify-content:space-between;gap:var(--spacing-2x);", " ", ";", ";", ";", ";", ""], (e) => e.$isClickMotion && _(), ({
  type: e
}) => e !== o.Line && t(["padding:0 var(--spacing-2x);"]), ({
  type: e
}) => e === o.Container && t(["background-color:var(--elements-bg-color-02);border-radius:var(--default-border-radius);z-index:0;"]), ({
  type: e
}) => e === o.Line && t(["border-top:var(--default-border-width) solid var(--elements-border-color);"]), ({
  type: e
}) => e === o.Outline && t(["border-radius:var(--default-border-radius);border:var(--default-border-width) solid var(--elements-border-color);"]), ({
  type: e,
  actionItem: i
}) => i && t(["&:hover{cursor:pointer;", ";", ";}&:focus-visible{", " outline-offset:2px;}"], e === o.Container && t(["opacity:var(--hover-container);"]), (e === o.Outline || e === o.Line) && t(["", ";"], I), L)), Y = c.forwardRef(({
  type: n = o.Container,
  actionItem: e = !1,
  onClick: i,
  children: s,
  ...l
}, d) => {
  const {
    isClickMotion: f,
    startClickMotion: p
  } = j(), m = (g) => {
    i && i(g), p();
  };
  return c.createElement($(e ? "button" : "div"), {
    type: n,
    actionItem: e,
    $isClickMotion: f,
    ...l,
    ref: d,
    onClick: m
  }, s);
});
export {
  O as D,
  u as L,
  W as R,
  X as a,
  Y as b,
  o as c,
  N as d,
  $ as e
};
